



































































































































































































































import Vue from "vue";
import AdvertisementPreview from "@/components/Form/AdvertisementPreview.vue";
import MessageBoxList from "@/components/MessageBoxList.vue";
import UpdatePaymentButton from "@/components/Button/UpdatePaymentButton.vue";
import CancelPaymentButton from "@/components/Button/CancelPaymentButton.vue";
import IssueInvoiceButton from "@/components/Button/IssueInvoiceButton.vue";
import IssueReceiptButton from "@/components/Button/IssueReceiptButton.vue";
// import { mapActions, mapState } from "vuex";
import { Advertisement } from "@/interfaces/advertisement";
import { PublishmentOrder } from "@/interfaces/publishmentorder";
import { PublicAdvertisement } from "@/interfaces/publicadvertisement";
import ConfirmAdvertisementButton from "@/components/Button/ConfirmAdvertisementButton.vue";
import RemandAdvertisementButton from "@/components/Button/RemandAdvertisementButton.vue";
import ChangePublishesAtButton from "@/components/Button/ChangePublishesAtButton.vue";
import SuspendAdvertisementButton from "@/components/Button/SuspendAdvertisementButton.vue";
import ResumeAdvertisementButton from "@/components/Button/ResumeAdvertisementButton.vue";
import ContactAboutAdvertisementButton from "@/components/Button/ContactAboutAdvertisementButton.vue";
import SyncAdvertisementButton from "@/components/Button/SyncAdvertisementButton.vue";
import DeleteAdvertisementButton from "@/components/Button/DeleteAdvertisementButton.vue";
export default Vue.extend({
  components: {
    AdvertisementPreview,
    MessageBoxList,
    UpdatePaymentButton,
    CancelPaymentButton,
    IssueInvoiceButton,
    IssueReceiptButton,
    ConfirmAdvertisementButton,
    RemandAdvertisementButton,
    ChangePublishesAtButton,
    SuspendAdvertisementButton,
    ResumeAdvertisementButton,
    ContactAboutAdvertisementButton,
    SyncAdvertisementButton,
    DeleteAdvertisementButton
  },
  computed: {
    publishmentOrder(): PublishmentOrder | undefined {
      if (!this.advertisement) {
        return;
      }
      return this.advertisement.publishmentOrder;
    },
    publicAdvertisement(): PublicAdvertisement | undefined {
      if (!this.advertisement) {
        return;
      }
      return this.advertisement.publicAdvertisement;
    }
  },
  data() {
    return {
      isLoading: false,
      advertisement: {} as Advertisement,
      mbKey: Symbol()
    };
  },
  methods: {
    onAdvertisementDeleted() {
      alert(
        '広告"' +
          this.advertisement.formattedAdvertisementId +
          '"を削除しました。'
      );
      this.$router.push({
        name: "AdministratorAdvertisementsIndex"
      });
    },
    // ...mapActions(["loadRegions", "loadLocalities", "loadCourses"]),
    clip(str?: string) {
      if (!str) return;
      navigator.clipboard.writeText(str);
      this.$buefy.snackbar.open({
        actionText: null,
        position: "is-top",
        message: "URLをコピーしました",
        type: "is-primary"
      });
    },
    async doSync() {
      await this.$store.dispatch("post", [
        this.advertisement["@id"] + "/sync",
        this.advertisement
      ]);
      await this.loadAdvertisement();
      this.$buefy.snackbar.open({
        actionText: null,
        position: "is-top",
        message: "連携が完了しました。",
        type: "is-primary"
      });
    },
    async loadAdvertisement() {
      this.isLoading = true;
      this.advertisement = await this.$store.dispatch(
        "reloadResource",
        "/api/adv/posts/" + this.$route.params.id
      );
      this.mbKey = Symbol();
      this.isLoading = false;
      this.$forceUpdate();
    }
  },
  created() {
    this.loadAdvertisement();
  },
  watch: {
    $route() {
      this.loadAdvertisement();
    }
  }
});
